module.exports = __webpack_public_path__ + "static/media/ashok-ramachandran.334257c7.jpg";